import { render, staticRenderFns } from "./SubirPlanilhaPizza.vue?vue&type=template&id=da125a2c"
import script from "./SubirPlanilhaPizza.vue?vue&type=script&lang=js"
export * from "./SubirPlanilhaPizza.vue?vue&type=script&lang=js"
import style0 from "./SubirPlanilhaPizza.vue?vue&type=style&index=0&id=da125a2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports